<template>
   <div>
      <div class="overline grey--text text--darken-1 mb-2">Historial de mantenimiento</div>

      <v-data-table
         :headers="headers"
         :items="bitacora"
         :loading="cargando"
         :items-per-page="10"
         no-data-text="Sin registros de mantenimiento"
         loading-text="Cargando..."
         class="elevation-1"
         sort-by="fechaActivacion"
         sort-desc
      >
         <template #item.fechaActivacion="{ item }">
            {{ formatearFecha(item.fechaActivacion) }}
         </template>

         <template #item.fechaDesactivacion="{ item }">
            <span v-if="item.fechaDesactivacion">{{ formatearFecha(item.fechaDesactivacion) }}</span>
            <v-chip v-else x-small color="error" dark>Activo</v-chip>
         </template>

         <template #item.acciones="{ item }">
            <v-btn
               icon
               small
               :color="item.mensaje ? 'primary' : 'grey'"
               :title="item.mensaje ? 'Ver / editar mensaje' : 'Agregar mensaje'"
               @click="abrirModal(item)"
            >
               <v-icon small>fa-comment-alt</v-icon>
            </v-btn>
         </template>
      </v-data-table>

      <!-- Modal de mensaje -->
      <v-dialog v-model="modalAbierto" max-width="520" persistent>
         <v-card>
            <v-card-title class="headline">
               <v-icon left color="primary">fa-comment-alt</v-icon>
               Mensaje de mantenimiento
            </v-card-title>

            <v-card-subtitle v-if="entradaSeleccionada" class="pt-1">
               Activado el {{ formatearFecha(entradaSeleccionada.fechaActivacion) }}
               por <strong>{{ entradaSeleccionada.activadoPor }}</strong>
            </v-card-subtitle>

            <v-card-text class="pt-3">
               <v-textarea
                  v-model="mensajeEditable"
                  label="Comentario / descripción del mantenimiento"
                  outlined
                  rows="4"
                  counter="1000"
                  maxlength="1000"
                  color="primary"
                  no-resize
               ></v-textarea>
            </v-card-text>

            <v-card-actions class="pb-4 px-6">
               <v-spacer></v-spacer>
               <v-btn text @click="cerrarModal">Cancelar</v-btn>
               <v-btn color="primary" dark :loading="guardando" @click="guardarMensaje">
                  Guardar
               </v-btn>
            </v-card-actions>
         </v-card>
      </v-dialog>

      <v-snackbar v-model="snack.visible" :color="snack.color" top right timeout="3000">
         {{ snack.texto }}
      </v-snackbar>
   </div>
</template>

<script>
import axios from 'axios'

export default {
   name: 'BitacoraMantenimiento',
   data: () => ({
      bitacora: [],
      cargando: false,
      modalAbierto: false,
      guardando: false,
      entradaSeleccionada: null,
      mensajeEditable: '',
      headers: [
         { text: 'Activado el',      value: 'fechaActivacion',   sortable: true,  width: 170 },
         { text: 'Activado por',     value: 'activadoPor',       sortable: false              },
         { text: 'Desactivado el',   value: 'fechaDesactivacion', sortable: true, width: 170 },
         { text: 'Desactivado por',  value: 'desactivadoPor',    sortable: false              },
         { text: 'Mensaje',          value: 'acciones',          sortable: false, align: 'center', width: 90 }
      ],
      snack: { visible: false, texto: '', color: 'success' }
   }),
   mounted() {
      this.cargarBitacora()
   },
   methods: {
      cargarBitacora() {
         this.cargando = true
         axios.get('api/BitacoraMantenimiento')
            .then((res) => { this.bitacora = res.data })
            .catch(() => { this.mostrarSnack('Error al cargar la bitácora', 'error') })
            .finally(() => { this.cargando = false })
      },
      abrirModal(item) {
         this.entradaSeleccionada = item
         this.mensajeEditable = item.mensaje || ''
         this.modalAbierto = true
      },
      cerrarModal() {
         this.modalAbierto = false
         this.entradaSeleccionada = null
         this.mensajeEditable = ''
      },
      guardarMensaje() {
         if (!this.entradaSeleccionada) return
         this.guardando = true
         const id = this.entradaSeleccionada.bitacoraMantenimientoId
         axios.put(`api/BitacoraMantenimiento/${id}/mensaje`, null, {
            params: { mensaje: this.mensajeEditable }
         })
            .then((res) => {
               const idx = this.bitacora.findIndex(b => b.bitacoraMantenimientoId === id)
               if (idx !== -1) this.$set(this.bitacora, idx, res.data)
               this.mostrarSnack('Mensaje guardado', 'success')
               this.cerrarModal()
            })
            .catch(() => { this.mostrarSnack('Error al guardar el mensaje', 'error') })
            .finally(() => { this.guardando = false })
      },
      formatearFecha(valor) {
         if (!valor) return '—'
         const d = new Date(valor)
         if (isNaN(d)) return valor
         const p = n => String(n).padStart(2, '0')
         return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()}  ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
      },
      mostrarSnack(texto, color) {
         this.snack = { visible: true, texto, color }
      }
   }
}
</script>
